import { Skeleton } from 'antd';

export const MissionDetailSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* En-tête de la Mission */}
      <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
          <div className="flex-shrink-0">
            <Skeleton.Avatar active size={48} shape="square" />
          </div>
          <div className="flex-grow">
            <Skeleton.Input active size="large" className="!w-[60%] !mb-2" />
            <Skeleton.Input active size="small" className="!w-[80%] !mb-4" />
            <div className="flex items-center gap-3">
              <Skeleton.Input active size="small" className="!w-[100px]" />
              <div className="flex-grow max-w-xs">
                <Skeleton.Input active size="small" className="!w-full" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 space-y-6 lg:space-y-0 lg:grid lg:grid-cols-2 lg:gap-6 lg:auto-rows-fr">
        {/* Section Packs Recommandés */}
        <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md h-full flex flex-col">
          <Skeleton.Input active size="small" className="!w-[200px] !mb-4" />
          <div className="flex-grow bg-gradient-to-r from-indigo-50 to-gray-50 rounded-lg p-4">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <Skeleton.Image active className="!w-[120px] !h-[120px]" />
              <div className="flex-grow">
                <Skeleton.Input active size="small" className="!w-[80%] !mb-2" />
                <Skeleton.Input active size="small" className="!w-[60%] !mb-4" />
                <div className="flex gap-2">
                  <Skeleton.Button active size="small" className="!w-[80px]" />
                  <Skeleton.Button active size="small" className="!w-[80px]" />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section Récompenses */}
        <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md h-full flex flex-col">
          <Skeleton.Input active size="small" className="!w-[200px] !mb-4" />
          <div className="flex-grow flex flex-wrap gap-4 items-center justify-center content-center">
            {[...Array(3)].map((_, index) => (
              <div key={index} className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg">
                <Skeleton.Image active className="!w-12 !h-12" />
                <div>
                  <Skeleton.Input active size="small" className="!w-[100px] !mb-1" />
                  <Skeleton.Input active size="small" className="!w-[60px]" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Section des Cartes Requises */}
      <div className="mt-6 bg-white rounded-xl p-4 sm:p-6 shadow-md">
        <div className="flex justify-between items-center mb-4">
          <Skeleton.Input active size="small" className="!w-[200px]" />
          <div className="flex items-center gap-2">
            <Skeleton.Input active size="small" className="!w-[150px]" />
            <Skeleton.Button active size="small" className="!w-[40px] !h-[24px]" />
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="bg-white rounded-lg shadow-sm p-4 relative">
              <div className="flex gap-4">
                <Skeleton.Image active className="!w-[200px] !aspect-[3/4]" />
                <div className="flex-grow">
                  <Skeleton.Input active size="small" className="!w-full !mb-2" />
                  <Skeleton.Input active size="small" className="!w-[80%]" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}; 